import ServicePage from "../components/site/ServicePage";
import { getService } from "../data/site";

const TASKS = [
  "Scheduled home checks",
  "Storm and weather inspections",
  "Package and mail collection",
  "Pre-arrival home preparation",
];

export default function PropertyManagement() {
  return (
    <ServicePage
      service={getService("property-management")}
      tagline="Your home, watched over while you're away."
      intro="Whether you split time between homes or travel often, we keep a caring eye on your South Shore property — checking in, catching problems early, gathering the mail, and having everything ready and welcoming before you walk back through the door."
      tasksTitle="What we handle"
      tasks={TASKS}
      quoteHeading="Inquire for Pricing"
    />
  );
}
